module.exports = __webpack_public_path__ + "static/media/hamburger.9572001d.svg";